import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App.jsx';
import TermsOfUse from './components/terms.jsx';
import PrivacyPolicy from './components/PrivacyPolicy.jsx'
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme.jsx";


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>

        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>

      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>
);
